/* eslint-disable no-unused-vars */
import SpecialEventApi from '../../../apis/special'

export const GET_BANNER_SPECIAL_EVENT_LIST = 'GET_BANNER_SPECIAL_EVENT_LIST'
export const GET_SPECIAL_EVENT_LIST = 'GET_SPECIAL_EVENT_LIST'
export const GET_SPECIAL_EVENT_LIST_TO_CATEGORY = 'GET_SPECIAL_EVENT_LIST_TO_CATEGORY'
export const GET_SPECIAL_EVENT_DETAIL = 'GET_SPECIAL_EVENT_DETAIL'


export default {
  
  [GET_BANNER_SPECIAL_EVENT_LIST]({ commit }) {
    return SpecialEventApi.getBannerSpecEvent()
  },

  [GET_SPECIAL_EVENT_LIST]({commit}) {
    return SpecialEventApi.getSpecEvent()
  },
  
 
  [GET_SPECIAL_EVENT_LIST_TO_CATEGORY]({ commit }) {
    return SpecialEventApi.getSpecEventListToCategory()
  },

  // SPECIAL DETAIL BS-01-010
  [GET_SPECIAL_EVENT_DETAIL]({commit}, spFeatureId) {
    return SpecialEventApi.getSpecEventDetail(spFeatureId)
  }
}